/**
 * Update :forAccountContent, :forNoAccountContent, :isPublic, :forPrivateAccount, :forPublicAccount
 * @param {String} htmlContent
 * @param {Object} appAccount
 * @returns {String} updated HTML string
 */
export function applyAccountRelatedClass (htmlContent, appAccount) {
  // console.log('applyAccountRelatedClass', appAccount)
  if (!htmlContent) return htmlContent

  if (!appAccount) {
    htmlContent = htmlContent.replaceAll(':forAccountContent', 'is-hidden')
    return htmlContent
  }

  htmlContent = htmlContent.replaceAll(':forNoAccountContent', 'is-hidden')

  const accountIsPublic = appAccount?.isPublic || appAccount?.is_public

  //
  htmlContent = htmlContent.replaceAll(':isPublic', accountIsPublic)

  // Limit visibility based on account isPublic
  if (accountIsPublic) {
    htmlContent = htmlContent.replaceAll(':forPrivateAccount', 'is-hidden')
  } else {
    htmlContent = htmlContent.replaceAll(':forPublicAccount', 'is-hidden')
  }
  return htmlContent
}
